export default [
	{ value: "atouchaway", locLabel: "ata_user", apiValue: "atouchaway" },
	{ value: "user:mobile", locLabel: "mobile_user", apiValue: "mobile" },
	{ value: "simplified", locLabel: "mobile_simplified", apiValue: "simplified" }
];
